module.exports = __webpack_public_path__ + "dashboard/img/pytanie-personalizowane.0c1212530101c53bbb8084715721c442.svg";